export class MysteryShopperQueryRequest {
    body: MysteryShopperQueryBody = new MysteryShopperQueryBody();
}

export class MysteryShopperQueryBody {
    ProcessName: string = 'DC Community Portal SR Process Wrapper WF';
    DCMethod: string = 'QUERY';
    DCLoginName: string = '';
    DCLanguage: string = 'ENU';
    DCIncomingHierarchy: MysteryShopperQueryDCIncomingHierarchy =
        new MysteryShopperQueryDCIncomingHierarchy();
}

export class MysteryShopperQueryDCIncomingHierarchy {
    MessageId: string = '';
    IntObjectName: string = 'DC Community Portal SR IO';
    MessageType: string = 'Integration Object';
    IntObjectFormat: string = 'Siebel Hierarchical';
    'ListOfDC Community Portal SR IO': MysteryShopperListOfDCCommunityPortalSRIO =
        new MysteryShopperListOfDCCommunityPortalSRIO();
}

export class MysteryShopperListOfDCCommunityPortalSRIO {
    'DC Community Portal SR': MysteryShopperDCCommunityPortalSRQuery =
        new MysteryShopperDCCommunityPortalSRQuery();
}

export class MysteryShopperDCCommunityPortalSRQuery {
    'SR Number': string = '';
    'SR Type': string = 'Service Excellence Programme';
    'Sub Type': string = 'Mystery Shopper Membership';
    CSN: string = '';
}
